import React from 'react';
import { connect } from 'react-redux';

import { showModal, hideModal } from 'actions/modalActions';
import Dialog from './ModalDialog';
import styles from './Modal.css';

import Portal from 'components/Portal';

const node = null;

class Modal extends Portal({ node, nodeClassName: styles['modal-portal'], timeout: 0 }) {
	constructor(props) {
		super(props);

		this.hide = this.hide.bind(this);
	}

	hide() {
		if (this.props.manual && typeof this.props.onRequestClose === 'function') {
			this.props.onRequestClose();
		} else {
			super.hide();
		}
	}

	visible(props) {
		return props.manual ? props.active : this.uid === props.visibleId;
	}

	renderChildren(props, active = false) {
		return <Dialog {...props} active={active} onRequestClose={this.hide} />;
	}
}

const mapStateToProps = ({ modal }) => ({ visibleId: modal });
const mapDispatchToProps = { showComponent: showModal, hideComponent: hideModal };

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Modal);
